export default "__VITE_ASSET__88667ba9__"